import { ProjectionGridBaseColumn } from '@bingads-webui/projection-grid-base-column';

export class FacebookImportToDoColumn extends ProjectionGridBaseColumn {
  constructor({ i18n, newI18n }) {
    const title = i18n.getString('ColumnName_WhatYouCanDo');
    super({
      name: 'facebookImportToDo',
      property: 'FacebookImportToDo',
      title,
      bodyClasses: ['grid-column-whatyoucando'],
      colClasses: ['col-superLongText'],
      type: 'string',
      helpAriaLabel: i18n.getString('Click to learn more about {{item}}', { item: title }),
    });
    this.newI18n = newI18n;
  }

  template() {
    const { newI18n } = this;
    return newI18n.getString(_TL_('Import campaigns directly from Meta Ads'));
  }
}
